import { makeEven } from '../utils';

export const useTableSide = (data, { actualAmount }) => {
  return {
    evenData: makeEven(data, actualAmount),
  };
};
